<template>
    <v-dialog class="dialog" v-model="dialog" persistent max-width="400">
        <v-card>
            <v-app-bar color="primary" dense dark>

                <v-toolbar-title>{{$t('prospect_finish.suggestion')}}</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn icon text @click="$emit('closeDialog')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>

            </v-app-bar>
            <v-form v-model="valid">

                <div class="text_internet ma-4">{{ $t('dialog_suggestion.title') }}</div>

                <v-text-field outlined class="mx-4" v-model="name" :label="$t('dialog_suggestion.name.label')" :disabled="loading" :placeholder="$t('dialog_suggestion.name.placeholder')" :rules="rules.name" append-icon="mdi-domain"></v-text-field>

                <v-card-actions class='d-flex justify-center align-center'>

                    <v-btn block :disabled="!valid || loading" :loading="loading" @click="onSendClick()" rounded color="#4ec5c1">{{ $t('send') }}</v-btn>

                </v-card-actions>

            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import validators from '../../../utils/validators';
import { mapActions, mapGetters } from 'vuex';
import { NEW_PROVIDER_NAME } from '../../../store/mutations';

export default {
    name: 'DialogSuggestion',
    data() {
        return {
            valid: false,
            name: '',
            rules: {
                name: [
                    v => validators.name.required(v) || this.$t('validators.name.required'),
                ],
            },
            loading: false,

        }
    },
    props: ['dialog'],

    computed: {

        ...mapGetters({ prospect: 'ProspectVuex/prospect'})

    },

    methods: {

        ...mapActions({
            sendProviderSuggestion: `ProspectVuex/${NEW_PROVIDER_NAME}`,

        }),

        async onSendClick() {

            try {

                await this.sendProviderSuggestion({ name: this.name, prospect: this.prospect })

                this.$emit('closeDialog')

                this.showToast(this.$t('dialog_suggestion.toast_msg'), this.$t('dialog_suggestion.toast_title'), 'success', {
                    position: "center",
                    icon: 'icon mdi mdi-email-check-outline',
                })

            } catch (error) {

                return this.$toast.error(error.message, this.$t('dialog_suggestion.error'), {
                    position: "center",
                    icon: 'icon mdi mdi-email-off-outline',
                })

            }
        }
    }
}
</script>

<style scoped>

.dialog {

    z-index: 999999999;

}

.text_internet {
    font-style: italic;
    font-weight: 700;
    font-size: 16px;
    text-align: center;
    line-height: 15px;
    color: #5B6076;
}


</style>